/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agenda_Undo_FailedInputs */



/**
* | output |
* | --- |
* | "We could not undo it. Try again in a moment." |
*
* @param {Agenda_Undo_FailedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_undo_failed = /** @type {((inputs?: Agenda_Undo_FailedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_Undo_FailedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Ongedaan maken is niet gelukt. Probeer het zo opnieuw.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'annulation n'a pas fonctionné. Réessayez dans un instant.")
	return /** @type {LocalizedString} */ ("We could not undo it. Try again in a moment.")
});